'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _asap = require('asap');

var _asap2 = _interopRequireDefault(_asap);

var _generate = require('./generate');

var _util = require('./util'); // The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.


var styleTag = null; // Inject a string of styles into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.

var injectStyleTag = function injectStyleTag(cssContents) {
  if (styleTag == null) {
    // Try to find a style tag with the `data-aphrodite` attribute first.
    styleTag = document.querySelector("style[data-aphrodite]"); // If that doesn't work, generate a new style tag.

    if (styleTag == null) {
      // Taken from
      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
      var head = document.head || document.getElementsByTagName('head')[0];
      styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.setAttribute("data-aphrodite", "");
      head.appendChild(styleTag);
    }
  }

  if (styleTag.styleSheet) {
    styleTag.styleSheet.cssText += cssContents;
  } else {
    styleTag.appendChild(document.createTextNode(cssContents));
  }
}; // Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)


var stringHandlers = {
  // With fontFamily we look for objects that are passed in and interpret
  // them as @font-face rules that we need to inject. The value of fontFamily
  // can either be a string (as normal), an object (a single font face), or
  // an array of objects and strings.
  fontFamily: function fontFamily(val) {
    if (Array.isArray(val)) {
      return val.map(fontFamily).join(",");
    } else if (typeof val === "object") {
      injectStyleOnce(val.fontFamily, "@font-face", [val], false);
      return '"' + val.fontFamily + '"';
    } else {
      return val;
    }
  },
  // With animationName we look for an object that contains keyframes and
  // inject them as an `@keyframes` block, returning a uniquely generated
  // name. The keyframes object should look like
  //  animationName: {
  //    from: {
  //      left: 0,
  //      top: 0,
  //    },
  //    '50%': {
  //      left: 15,
  //      top: 5,
  //    },
  //    to: {
  //      left: 20,
  //      top: 20,
  //    }
  //  }
  // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
  // to use `animationName` here. Improve that so we can call this
  // `animation` instead of `animationName`.
  animationName: function animationName(val) {
    if (typeof val !== "object") {
      return val;
    } // Generate a unique name based on the hash of the object. We can't
    // just use the hash because the name can't start with a number.
    // TODO(emily): this probably makes debugging hard, allow a custom
    // name?


    var name = 'keyframe_' + (0, _util.hashObject)(val); // Since keyframes need 3 layers of nesting, we use `generateCSS` to
    // build the inner layers and wrap it in `@keyframes` ourselves.

    var finalVal = '@keyframes ' + name + '{';
    Object.keys(val).forEach(function (key) {
      finalVal += (0, _generate.generateCSS)(key, [val[key]], stringHandlers, false);
    });
    finalVal += '}';
    injectGeneratedCSSOnce(name, finalVal);
    return name;
  }
}; // This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)

var alreadyInjected = {}; // This is the buffer of styles which have not yet been flushed.

var injectionBuffer = ""; // A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.

var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
  if (!alreadyInjected[key]) {
    if (!isBuffering) {
      // We should never be automatically buffering on the server (or any
      // place without a document), so guard against that.
      if (typeof document === "undefined") {
        throw new Error("Cannot automatically buffer without a document");
      } // If we're not already buffering, schedule a call to flush the
      // current styles.


      isBuffering = true;
      (0, _asap2['default'])(flushToStyleTag);
    }

    injectionBuffer += generatedCSS;
    alreadyInjected[key] = true;
  }
};

var injectStyleOnce = function injectStyleOnce(key, selector, definitions, useImportant) {
  if (!alreadyInjected[key]) {
    var generated = (0, _generate.generateCSS)(selector, definitions, stringHandlers, useImportant);
    injectGeneratedCSSOnce(key, generated);
  }
};

exports.injectStyleOnce = injectStyleOnce;

var reset = function reset() {
  injectionBuffer = "";
  alreadyInjected = {};
  isBuffering = false;
  styleTag = null;
};

exports.reset = reset;

var startBuffering = function startBuffering() {
  if (isBuffering) {
    throw new Error("Cannot buffer while already buffering");
  }

  isBuffering = true;
};

exports.startBuffering = startBuffering;

var flushToString = function flushToString() {
  isBuffering = false;
  var ret = injectionBuffer;
  injectionBuffer = "";
  return ret;
};

exports.flushToString = flushToString;

var flushToStyleTag = function flushToStyleTag() {
  var cssContent = flushToString();

  if (cssContent.length > 0) {
    injectStyleTag(cssContent);
  }
};

exports.flushToStyleTag = flushToStyleTag;

var getRenderedClassNames = function getRenderedClassNames() {
  return Object.keys(alreadyInjected);
};

exports.getRenderedClassNames = getRenderedClassNames;

var addRenderedClassNames = function addRenderedClassNames(classNames) {
  classNames.forEach(function (className) {
    alreadyInjected[className] = true;
  });
};

exports.addRenderedClassNames = addRenderedClassNames;
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {Object[]} styleDefinitions style definition objects as returned as
 *     properties of the return value of StyleSheet.create().
 */

var injectAndGetClassName = function injectAndGetClassName(useImportant, styleDefinitions) {
  // Filter out falsy values from the input, to allow for
  // `css(a, test && c)`
  var validDefinitions = styleDefinitions.filter(function (def) {
    return def;
  }); // Break if there aren't any valid styles.

  if (validDefinitions.length === 0) {
    return "";
  }

  var className = validDefinitions.map(function (s) {
    return s._name;
  }).join("-o_O-");
  injectStyleOnce(className, '.' + className, validDefinitions.map(function (d) {
    return d._definition;
  }), useImportant);
  return className;
};

exports.injectAndGetClassName = injectAndGetClassName;